// 系统设置
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import { Card, Table, Space, Dropdown, Button, App, Drawer, Spin, Tree } from 'antd'
import { MenuOutlined, EditOutlined, DeleteOutlined, PlusOutlined, DownOutlined } from '@ant-design/icons'
import { getUserInfo, getPurviewInfo, setPurviewInfo } from '@/server/permission_settings.js'
import { getTreeDataByDelayeringData } from '@/common/js/common.js'

function PermissionSettings () {
  const { message } = App.useApp();
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const token = localStorage.getItem('dock_token');
  const [loading, setLoading] = useState(false)//加载中···
  const [isSubmit, setIsSubmit] = useState(false);

  //表格筛选条件
  const [dataList, setDataList] = useState({
    dataSource: [],//表格数据
  });

  const [purviewList, setPurviewList] = useState({//权限列表
    UID: '',//当前选择的ID
    isShowBtn: true,
    isOpen: false,//是否打开抽屉
    isLoading: false,
    allPurview: [],//所有权限
    curPurview: [],//当前拥有的权限
    subPurview: [],//需要提交的权限
  })

  const [total, _total] = useState(0);
  const [searchCriteria, _searchCriteria] = useState({
    title: '',
    order: '',
    status: '',
    current: 1,
    pageSize: 10,
  });

  // 获取用户信息
  const getAllData = async () => {
    setLoading(true)
    let dat = dataList
    let res = await getUserInfo({ access_token: token })
    if (res.ret === 200) {
      dat.dataSource = res.data.items
    } else {
      message.warning(res.msg || '系统出错啦，请稍后重试')
    }
    _total(res.data.total || 0)
    setDataList({ ...dat })
    setLoading(false)
  }
  // 获取权限信息
  const getPurviewData = async (id) => {
    let res = await getPurviewInfo({
      access_token: token,
      UID: id
    })
    let pur = purviewList
    if (res.ret === 200) {
      pur.allPurview = JSON.parse(
        JSON.stringify(
          getTreeDataByDelayeringData(res.data.menus, 'parentid', 'id')
        )
          .replaceAll('cname', 'title')
          .replaceAll('id', 'key')
          .replaceAll('parentkey', 'parentid')
      )
      console.log('-----', pur.allPurview);
      pur.curPurview = res.data.menuid
      pur.subPurview = res.data.menuid
    } else {
      message.warning(res.msg || '系统出错啦，请稍后重试')
    }
    pur.isLoading = false
    setPurviewList({ ...pur })

  }

  // 分页、排序、筛选变化时触发
  const handleTableChange = (newPagination, filters, sorter) => {
    let searchBefore = { ...searchCriteria };
    // 分页
    searchBefore.current = newPagination.current;
    searchBefore.pageSize = newPagination.pageSize;
    _searchCriteria({ ...searchBefore })
    getAllData() //加载列表
  };

  //表格操作列表
  const dropDownOption = (data) => {
    let typeArr = [
      {
        key: '1',
        label: (
          <div onClick={() => {
            let pur = purviewList
            pur.UID = data.id
            pur.isOpen = true
            pur.isLoading = true
            pur.allPurview = []
            setPurviewList({ ...pur })
            getPurviewData(data.id)
          }}>
            <EditOutlined className='marR10' /> 设置权限
          </div>
        ),
      },
      {
        key: '2',
        label: (
          <div
            onClick={() => {

            }}>
            <DeleteOutlined className='marR10' /> 删除
          </div>
        ),
      },
    ]
    return { items: typeArr }
  }

  //提交 权限管理
  const submitPermissionSettings = async () => {
    let pur = { ...purviewList };
    let list = {
      access_token: token,
      UID: purviewList.UID,
      menuids: purviewList.subPurview ? purviewList.subPurview.join(',') : '',
    }
    setIsSubmit(true);
    let res = await setPurviewInfo(list)
    setIsSubmit(false);
    if (res.ret === 200) {
      pur.isLoading = false
      pur.isOpen = false
      pur.isShowBtn = true
      message.success('更改成功！');
      getAllData()
    } else {
      pur.isLoading = false
      message.warning(res.msg || '系统出错啦，请重试！');
    }
    setPurviewList({ ...pur })
  }


  // 表头
  const columns = [
    {
      title: '账号',
      dataIndex: 'username',
      render: (text, record) => {
        return (
          <div>
            {
              text
                ? <span>{text}</span>
                : <div style={{ color: 'rgba(255,255,255,0.25)' }}>-</div>
            }
          </div>
        )
      }
    },
    {
      title: '是否禁用',
      dataIndex: 'member_status',
      render: (text, record) => {
        return (
          <div>
            {
              text
                ? <span>{text}</span>
                : <div style={{ color: 'rgba(255,255,255,0.25)' }}>-</div>
            }
          </div>
        )
      }
    },
    {
      title: '操作',
      dataIndex: '',
      align: 'center',
      width: 120,
      render: (text, record) => {
        return (
          <Dropdown
            menu={dropDownOption(record)}
            placement="bottom"
          >
            <MenuOutlined className='pointer col_primary' />
          </Dropdown>
        )
      }
    },
  ]



  useEffect(() => {
    getAllData()
    // eslint-disable-next-line
  }, [])

  return (
    <Card className='mar24' style={{ border: 0 }}>
      {/* <div className="flex_row pdRL12 pdB16 jcr align_center">
        <Button type="primary" icon={<PlusOutlined />} onClick={() => {
          message.warning('功能暂未开发，请稍后重试~')
        }}>
          新增
        </Button>
      </div> */}
      {/* 甲方所有信息表格 */}
      <Table
        loading={loading}
        columns={columns}
        dataSource={dataList.dataSource}
        rowKey='id'
      >

      </Table>

      <Drawer
        title="修改权限"
        width={288}
        placement="right"
        onClose={() => {
          let pur = purviewList
          pur.isOpen = false
          pur.isShowBtn = true
          setPurviewList({ ...pur })
        }}
        open={purviewList.isOpen}
        extra={
          <Space>
            <Button
              type="primary"
              disabled={purviewList.isShowBtn}
              loading={isSubmit}
              onClick={() => { submitPermissionSettings() }}
            >
              确定
            </Button>
          </Space>
        }
      >
        <Spin spinning={purviewList.isLoading}>
          <Tree
            style={{ backgroundColor: '#1f1f1f' }}
            checkable
            showLine
            selectable={false}
            autoExpandParent={true}
            defaultExpandAll='true'
            switcherIcon={<DownOutlined />}
            defaultExpandParent={true}
            checkedKeys={purviewList.curPurview}//默认选中复选框的节点
            treeData={purviewList.allPurview}
            onCheck={(key, info) => {
              let pur = purviewList
              pur.curPurview = key ? key : []
              pur.subPurview = key && info.halfCheckedKeys ? key.concat(info.halfCheckedKeys) : []
              pur.isShowBtn = false
              setPurviewList({ ...pur })
            }}
          />
        </Spin>
      </Drawer>
    </Card>
  )
}
export default PermissionSettings;